const BlockState = {
  type: "state",
  name: "View",
  slug: "view",
  elements: [],
  mobile: {},
  desktop: {
    bgMediaType: "none",
    bgFillType: "color",
    bgColor: "#000000:0",
  },
  sync: ["bgFillType", "bgMediaType"],
};

export default BlockState;
